module.exports = __webpack_public_path__ + "assets/3a0a4e02cbf6471c4126052e6a12e685.png";